import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/shared';
import { DisplayService, UserRoleService } from '../..';

@Component({
    selector: 'app-landing-page',
    template: ``,
    styles: [],
    standalone: false
})
export class LandingPageComponent extends BaseComponent implements OnInit {
  constructor(private userRole: UserRoleService, private router: Router, private display:DisplayService) {
    super();
  }

  ngOnInit() {
    const isSuperVisorView =  this.display.summaryViewValidate();
    if (this.userRole.omni || this.userRole.overseer || (this.userRole.supervisor && isSuperVisorView)) {
      this.router.navigate(['summary']);
    } else if (this.userRole.auditor) {
      this.router.navigate(['auditor']);
    } else if (this.userRole.supervisor) {
      this.router.navigate(['supervisor']);
    } else if (this.userRole.controller) {
      this.router.navigate(['controller']);
    } else {
      this.router.navigate(['dashboard']);
    }
  }
}
